import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { LabelApiService } from 'features/social-label/api/label-api.service';
import { UserListParams, UserResponse } from 'features/users';
import { userQueryKeys } from 'features/users/use-cases/query-keys';
import qs from 'qs';

const { getLabel } = LabelApiService();

const getUsersQuery = (
  params: UserListParams,
  options?: UseQueryOptions<UserResponse>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<UserResponse>;
  options?: UseQueryOptions<UserResponse>;
} => ({
  queryKey: userQueryKeys.list(params),
  queryFn: ({ signal }) =>
    getLabel(params, {
      config: {
        signal,
        paramsSerializer: {
          serialize: (queryParams) =>
            qs.stringify(queryParams, {
              arrayFormat: 'repeat',
              encode: true,
            }),
        },
      },
    }),
  ...options,
});

export const useGetLabelList = (
  params: UserListParams,
  options?: UseQueryOptions<UserResponse>,
) => {
  const { message } = App.useApp();

  return useQuery<UserResponse, Error>(
    getUsersQuery(params, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      ...options,
    }),
  );
};
